import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M225-440q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h510q16 0 28 12 12 11 12 28t-12 28q-12 12-28 12H225Z"/>',
  f: '<path d="M225-440q-16 0-28-12t-11-28q0-17 11-28 12-12 28-12h510q16 0 28 12 12 11 12 28t-12 28q-12 12-28 12H225Z"/>',
};

export default data;
